import { useContext } from 'react';
import { AuthModalContext } from 'state/contexts/authModalContext';

const useAuthModal = () => {
  const context = useContext(AuthModalContext);

  if (!context) {
    throw new Error('useAuthModal must be used within AuthModalProvider');
  }

  return context;
};

export default useAuthModal;
